import React from 'react'
import { UserStatusFilter } from '@myapp/contract'
import { Input } from '../../../shared/ui/controls/Input/Input'
import { FieldWrapper } from '../../../shared/ui'
import { FilterBar } from '../../../shared/ui/layouts/FilterBar'
import Select from '../../../shared/ui/controls/Select/Select'
import { GewerkSearchSelect } from '../../../entities/gewerk'
import { userColumns } from '../model/constants'

interface Props {
  search: string
  onSearchChange: (value: string) => void
  status: UserStatusFilter
  onStatusChange: (value: UserStatusFilter) => void
  tradeId?: number | null
  onTradeIdChange?: (value: number | null) => void
}

const STATUS_OPTIONS = [
  { label: 'Aktiv', value: 'active' },
  { label: 'Archiviert', value: 'archived' },
  { label: 'Alle', value: 'all' },
]

export const UserFilterBar: React.FC<Props> = ({
  search,
  onSearchChange,
  status,
  onStatusChange,
  tradeId,
  onTradeIdChange,
}) => {
  return (
    <FilterBar actionsButtons columns={userColumns}>
      <FieldWrapper label="Name">
        <Input
          value={search}
          onChange={onSearchChange}
          placeholder=""
          clearable
        />
      </FieldWrapper>
      <FieldWrapper label="E-Mail" />
      <FieldWrapper label="Rolle" />
      <FieldWrapper label="Gewerk">
        <GewerkSearchSelect
          value={tradeId ?? null}
          onChange={(id) => onTradeIdChange?.(id)}
        />
      </FieldWrapper>
      <FieldWrapper label="Status">
        <Select
          options={STATUS_OPTIONS}
          value={status}
          onChange={(v) => onStatusChange(v as UserStatusFilter)}
        />
      </FieldWrapper>
    </FilterBar>
  )
}
